export default "__VITE_ASSET__C_t4ktFo__"